import { NoPhotography } from '@mui/icons-material'
import { ButtonBase, Card, CardContent, Grid, Theme, Typography } from '@mui/material'
import { useEffect, useState } from 'react'

interface PhotoCardProps {
  complete?: boolean
  disabled?: boolean
  label?: string
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  src?: string
}

const height = 84.375

export default function PhotoCard({ complete, disabled, label, onClick, src }: PhotoCardProps) {
  const [missing, setMissing] = useState<boolean>(!Boolean(src))

  useEffect(() => {
    setMissing(!Boolean(src))
  }, [src])

  const getBackgroundColor = (theme: Theme) => {
    if (disabled) {
      return theme.palette.grey[400] // '#b0a8b9'
    } else if (complete) {
      return theme.palette.success.main // '#009c45'
    }

    return theme.palette.error.main // '#ff0000'
  }

  return (
    <Card
      component={ButtonBase}
      onClick={onClick}
      sx={theme => ({
        backgroundColor: getBackgroundColor(theme),
        color: '#fff',
        p: 1,
        width: '220px'
      })}
    >
      <CardContent>
        <Grid container spacing={0} alignItems='center' justifyContent='center'>
          <Grid item sx={{ minHeight: height, maxHeight: height }}>
            {!missing && <img alt={label} src={src} width={150} height={height} onError={() => setMissing(true)} />}

            {missing && <NoPhotography fontSize='large' sx={{ height: height }} />}
          </Grid>

          <Grid item xs={12}>
            {label && (
              <Typography align='center' variant='body2'>
                {label}
              </Typography>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
